import { tooltipText } from 'shared/constants/tooltipText'
import { type IDropdownItem } from 'shared/ui'
import { type Inbox } from 'entities/Inbox/model/Inbox'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export const getPFTInboxDropdownItemProps = (
  inbox: Inbox,
  entities: IEntitiesStore
): Partial<IDropdownItem> => {
  const { featureFlagsStore, inboxesStore } = entities
  const inteliquentCalling = featureFlagsStore.inteliquent_calling
  const isPFTDisabled = inbox?.isPFTInbox && !inteliquentCalling
  return {
    disabled: isPFTDisabled,
    disabledChildren: isPFTDisabled,
    parentTooltipProps: isPFTDisabled
      ? {
          label: tooltipText.disabledCall(inboxesStore.nonPFTInboxNumberType),
          fullWidth: true,
          placement: 'right',
        }
      : undefined,
  }
}
